<template>
  <div class="hidden md:grid grid-cols-12 py-20 px-6">
    <div class="col-span-5 flex items-center justify-end px-10">
      <div class="relative">
        <img
          class="h-96 w-auto"
          :src="require('@/assets/images/article-1.png')"
          alt="Doctor"
        />
      </div>
    </div>

    <div class="col-span-7 flex items-center justify-start px-8">
      <div class="flex flex-col max-w-2xl">
        <h1
          class="text-left pb-6 text-black text-4xl font-extrabold leading-snug"
        >
          Telemedicine: The Future of Healthcare is Now in the Philippines
        </h1>
        <p class="text-gray-700 text-base leading-7">
          The way Filipinos access healthcare is changing — and telemedicine is
          leading this transformation. With the rise of digital technology and
          the growing need for convenient, affordable care, telemedicine has
          quickly become an essential part of everyday life.
        </p>
        <p class="text-gray-700 text-base leading-7 mt-4">
          Using just a mobile phone or computer, Filipinos can now consult
          licensed doctors online — no travel, no long waits. From minor
          illnesses and follow-ups to mental health support and e-prescriptions,
          telemedicine puts quality healthcare within reach, even for those in
          remote areas.
        </p>
        <p class="text-gray-700 text-base leading-7 mt-4">
          Our platform makes it easy. Book an online consultation, speak to a
          doctor, and receive your e-prescription — all from the comfort of your
          home. Healthcare has never been this accessible.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SVGFacebook from "@/components/svgs/facebook.vue";
import SVGStar from "@/components/svgs/star.vue";

export default {
  components: {
    SVGFacebook,
    SVGStar,
  },
};
</script>
